export default class ReanalysRequest {
  constructor() {
    this.userId = '';
    this.dateStart = '';
    this.dateEnd = '';
    this.longitude = '';
    this.latitude = '';
  }
}